import { DocumentStatusResource } from '../../../types';
import { InceptHeader } from '../../constants/InceptHeader';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';

export const getDocumentCurrentStatus = async (
  constructGet: ConstructGet,
  documentId: string,
  definitionName: string,
  statusDefinitionName: string,
): Promise<NonPaginatedResponse<DocumentStatusResource> | undefined> =>
  constructGet(
    `${DOCUMENTS_BASE_PATH}/${documentId}/status/${statusDefinitionName}`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
  );
